<template>
  <div class="ucenter-wrap" v-if="userFullInfo">
    <div class="ucenter-header">我的账户</div>
    <!-- 可享优惠 -->
    <div class="module enjoy-discount__wrap" v-if="true">
      <div class="module-title">您可享受的礼遇</div>
      <div class="module-main enjoy-discount">
        <div class="discount-item" v-for="(benefit, index) in userFullInfo.benefit_info" :key="index">
          <div class="discount-item__icon">
            <img :src="benefit.icon" :alt="benefit.title" />
          </div>
          <div class="discount-item__info">
            <div class="discount-item__info-title">{{benefit.title}}</div>
            <div class="discount-item__info-desc" v-html="benefit.txt.join('<br/>')"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 专属活动 -->
    <!-- <div class="module" v-if="userFullInfo.active_info && userFullInfo.active_info.length">
      <div class="module-title">您的专属活动</div>
      <div class="module-main exclusive-events">
        <div class="link" v-for="(item, index) in userFullInfo.active_info" :key="index"  @click="showSkinText(index)">
          <picture v-if="index === 0">
            <source v-if="item.small_image" media="(max-width:640px)" :srcset="item.small_image" />
            <img media="(min-width:768px)" :src="item.big_image" alt="Sisley Paris" />
          </picture>
        </div>
      </div>
    </div> -->
    <!-- 即将到期 -->
    <div class="module expiring-offers__wrap">
      <div class="module-title">您即将到期的礼券</div>
      <div class="module-main expiring-offers">
        <template v-if="userFullInfo.coupon_list && userFullInfo.coupon_list.length">
          <div v-for="(item, index) in userFullInfo.coupon_list" :key="index" class="coupon-item">
            <div class="coupon-item__info">
              <template v-if="item.coupon_type == 'product_coupon'">
                <div class="coupon-item__info-value">
                  <img class="coupon-item__image" :src="item.coupon_pic" :alt="item.desc" />
                </div>
                <div class="coupon-item__info-extra">
                  <div class="coupon-item__info-extra__name">{{item.product_coupon_name}}</div>
                  <div class="coupon-item__info-extra__time" v-if="!item.vaild_desc">{{ item.start | dataFmt | strLength(10) }} - {{ item.end | dataFmt | strLength(10) }}</div>
                </div>
              </template>
              <template v-else-if="item.coupon_type == 'coupon_discount'">
                <div class="coupon-item__info-value">
                  <!-- <div class="coupon-item__info-value__number">{{item.product_discount}}折</div> -->
                  <div class="coupon-item__info-value__symbol">{{item.product_discount}}折</div>
                </div>
                <div class="coupon-item__info-extra">
                  <div class="coupon-item__info-extra__name">{{item.desc}}</div>
                  <div class="coupon-item__info-extra__desc">全场通用</div>
                  <div class="coupon-item__info-extra__time" v-if="item.vaild_desc">{{ item.valid_desc }}</div>
                  <div class="coupon-item__info-extra__time" v-else>{{ item.start | dataFmt | strLength(10) }} - {{ item.end | dataFmt | strLength(10) }}</div>
                </div>
              </template>
              <template v-else>
                <div class="coupon-item__info-value">
                  <div class="coupon-item__info-value__symbol">￥</div>
                  <div class="coupon-item__info-value__number">{{item.price}}</div>
                </div>
                <div class="coupon-item__info-extra">
                  <div class="coupon-item__info-extra__name">{{item.desc}}</div>
                  <div class="coupon-item__info-extra__desc">满{{item.require}}可用，全场通用</div>
                  <div class="coupon-item__info-extra__time" v-if="item.vaild_desc">{{ item.valid_desc }}</div>
                  <div class="coupon-item__info-extra__time" v-else>{{ item.start | dataFmt | strLength(10) }} - {{ item.end | dataFmt | strLength(10) }}</div>
                </div>
              </template>
            </div>
            <div class="coupon-item__btns">
              <button class="btn__cls" @click="toHome">立即使用</button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="expiring-offers__empty tile-empty">
            <div class="empty-text">您还没有任何礼券</div>
            <button class="btn" @click="toHome">继续购物</button>
          </div>
        </template>
      </div>
    </div>
    <!-- 最近购买 -->
    <div class="module">
      <div class="module-title">您最近购买的商品</div>
      <div class="module-main latest-purchase">
        <template v-if="userFullInfo.order_list && userFullInfo.order_list.length">
          <div v-for="(item, index) in userFullInfo.order_list" :key="index" class="latest-purchase__item">
            <OrderItem :source="item" />
          </div>
        </template>
        <template v-else>
          <div class="latest-purchase__empty tile-empty">
            <div class="empty-text">您还没有购买过任何产品</div>
            <button class="btn" @click="toHome">立即购买</button>
          </div>
        </template>
      </div>
    </div>
    <!-- 为您推荐 -->
    <div class="module show-for-md">
      <Recommend :isTitle="true" region="account_rec" />
    </div>
    <!-- 美丽肌密弹框 -->
    <Dialog :show="showDialog == 1" wrapCls="offline_appointment" @hide="hide">
      <div class="qrcode-wrap_skin" v-if="skinText">
        <img class="qrcode-imgage" :src="skinText" />
      </div>
    </Dialog>
    <!-- 企业微信弹框 -->
    <Dialog :show="showDialog == 2" wrapCls="notice__wrap" @hide="hide">
      <a class="notice_link">
        <img class="show-for-md" :src="pc_url" />
        <img class="hide-for-md" :src="h5_url" />
      </a>
    </Dialog>
  </div>
</template>

<script>
import OrderItem from '@/components/OrderItem.vue';
import Recommend from '@/components/Recommend.vue';
import types from "@/store/types";
import api from "@/utils/api";
import Dialog from '@/components/Dialog.vue';

export default {
  components: { OrderItem, Recommend, Dialog },
  data() {
    return {
      benefitInfo: null,
      expiringOffers: null,
      latestOrder: null,
      activeInfo: null,
      showDialog: false,
      dialog: true
    };
  },
  created() {
    if (this.isLogin && !this.$store.state.userFullInfo) {
      this.loadSource();
    }
    this.skinText = process.env.VUE_APP_OSS_PATH + '/mp/skintest/share/skin_text.png'
    this.pc_url = process.env.VUE_APP_OSS_PATH + '/landing/ucenter_pc.jpg'
    this.h5_url = process.env.VUE_APP_OSS_PATH + '/landing/toQywx.jpg'
  },
  methods: {
    loadSource() {
      api[types.GET_ACCOUNT_INFO]({
        key: 'myaccount'
      }).then(res => {
        if (res.code == 1) {
          let { base_info, customer_level, total_points, shipping_address, benefit_info, coupon_list, order_list, active_info  } = res.data;
          this.$store.commit('saveUserFullInfo', {
            base_info,
            customer_level,
            total_points,
            shipping_address,
            benefit_info,
            coupon_list,
            order_list,
            active_info,
            original_level: res.data.original_level || 0
          });
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => console.warn(err));
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
    showSkinText(index) {
      index === 0 ? this.showDialog =1 : this.showDialog = 2
    },
    hide() { this.showDialog = ''; },
  },
  computed: {
    userFullInfo() {
      return this.$store.state.userFullInfo;
    }
  },
  filters: {
    dataFmt(date) {
      if (isNaN(date)) {
        return date?.replace(/-/g, '.');
      } else {
        return new Date(String(date).padEnd(13, 0)).toLocaleDateString('cn',{year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '.');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .tile-empty {
    width: 100%; padding: 50px 0 44px 0; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #F8F8F8;
    .empty-text { font-size: 0.75rem; color: #000000; }
    .btn { margin-top: 1.25rem; color: #FFFFFF; background: #000000; border: none; }
  }
  .ucenter-wrap {
    .ucenter-header { font-size: 1.125rem; color: #000000; font-weight: 700; margin: 1rem 0; display: none; }
    .module {
      width: 100%; padding: 0 1.25rem; 
      &:first-child {
        .module-title { margin-top: 0; }
      }
      .module-title { font-size: 0.875rem; color: #575757; margin: 1.25rem 0; }
      .module-main {
        &.enjoy-discount {
          .discount-item {
            width: 100%; border: 1px solid #D2D2D2; padding: 1.5rem 3rem 1.875rem 3rem; text-align: center; margin-top: 1.25rem;
            &:first-child { margin-top: 0; }
            .discount-item__icon {
              img { width: 2rem; height: 2rem; }
            }
            .discount-item__info {
              margin-top: 0.875rem;
              .discount-item__info-title { font-size: 1rem; color: #000000; font-weight: 700; }
              .discount-item__info-desc { font-size: 0.875rem; color: #999999; margin-top: 0.5rem; }
            }
          }
        }
        &.expiring-offers {
          .coupon-item {
            width: 100%; border: 1px solid #DFDFDF; border-radius: 0.625rem; margin-top: 1.25rem;
            &:first-child { margin-top: 0; }
            .coupon-item__info {
              display: flex; justify-content: flex-start; align-items: center; padding: 1.25rem 1.25rem 0.625rem 1.25rem;
              .coupon-item__info-value {
                color: #4C6149; line-height: 1; display: flex; justify-content: flex-start; align-items: flex-end;
                .coupon-item__info-value__symbol { font-size: 1.125rem; }
                .coupon-item__info-value__number { font-size: 1.875rem; }
                .coupon-item__image { min-width: 3.4375rem; height: auto; max-height: 68px; }
              }
              .coupon-item__info-extra {
                margin-left: 1.5rem;
                .coupon-item__info-extra__name { font-size: 0.875rem; color: #000000; font-weight: 700; }
                .coupon-item__info-extra__desc { font-size: 0.875rem; color: #575757; }
                .coupon-item__info-extra__time { font-size: 0.875rem; color: #575757; }
              }
            }
            .coupon-item__btns {
              width: 100%; border-top: 0.0625rem #DFDFDF dashed; position: relative;
              &:before {
                content: ""; width: 0.625rem; height: 1.25rem; position: absolute; left: -0.0625rem; top: -0.625rem; background: #FFFFFF;
                border-radius: 0 3.125rem 3.125rem 0; border-top: 0.0625rem solid #DFDFDF; border-bottom: 0.0625rem solid #DFDFDF; border-right: 0.0625rem solid #DFDFDF;
              }
              &:after {
                content: ""; width: 0.625rem; height: 1.25rem; position: absolute; right: -0.0625rem; top: -0.625rem; background: #FFFFFF;
                border-radius: 3.125rem 0 0 3.125rem; border-top: 0.0625rem solid #DFDFDF; border-bottom: 0.0625rem solid #DFDFDF; border-left: 0.0625rem solid #DFDFDF;
              }
              .btn__cls { width: 100%; border: none; font-size: 0.875rem; font-weight: 700; padding: 0.9375rem 0; cursor: pointer; }
            }
          }
        }
        &.latest-purchase {
          .latest-purchase__item {
            width: 100%; margin-top: 1.25rem;
            &:first-child { margin-top: 0; }
          }
        }
        &.exclusive-events {
          .link {
            display: block; margin-top: 1.25rem;
            &:first-child { margin-top: 0; }
            picture {
              display: block; width: 100%;
              img { width: 100%; height: auto; }
            }
          }
        }
      }
      // 
      &.enjoy-discount__wrap .module-title { margin: 10px 0 1rem 0; }
    }
  }
  .qrcode-wrap_skin{
      width: 100%;
      // height: 285px;
      padding: 50px;
  }
  @media only screen and (min-width: 64rem) {
    .ucenter-wrap {
      .ucenter-header { display: block; }
      .module {
        padding: 0;
        .module-main {
          &.enjoy-discount {
            display: flex; justify-content: flex-start;
            .discount-item {
              width: 50%; margin-top: 0;
              &:not(:first-child) { border-left: none; }
            }
          }
          &.expiring-offers {
            display: flex; justify-content: flex-start; flex-wrap: wrap;
            .coupon-item {
              width: calc((100% - 2.5rem) / 3); margin: 1.25rem 1.25rem 0 0;
              &:nth-child(-n+3) { margin-top: 0; }
              &:nth-child(3n) { margin-right: 0; }
            }
          }
        }
      }
    }
    .qrcode-wrap_skin{
      width: 360px;
      // height: 360px;
      padding: 60px;
    }
  }
</style>